export const ESPECIEFICHASIMILITUD_LOADING = 'ESPECIEFICHASIMILITUD_LOADING';
export const ESPECIEFICHASIMILITUD_LOADED = 'ESPECIEFICHASIMILITUD_LOADED';
export const ESPECIEFICHASIMILITUD_ERROR = 'ESPECIEFICHASIMILITUD_ERROR';

export const ENDEMISMO_LOADING = 'ENDEMISMO_LOADING';
export const ENDEMISMO_LOADED = 'ENDEMISMO_LOADED';
export const ENDEMISMO_ERROR = 'ENDEMISMO_ERROR';

export const FILTROSELECT_LOADING = 'FILTROSELECT_LOADING';
export const FILTROSELECT_LOADED = 'FILTROSELECT_LOADED';
export const FILTROSELECT_ERROR = 'FILTROSELECT_ERROR';

export const HABITATESTRATO_LOADING = 'HABITATESTRATO_LOADING';
export const HABITATESTRATO_LOADED = 'HABITATESTRATO_LOADED';
export const HABITATESTRATO_ERROR = 'HABITATESTRATO_ERROR';

export const TIPOHABITAT_LOADING = 'TIPOHABITAT_LOADING';
export const TIPOHABITAT_LOADED = 'TIPOHABITAT_LOADED';
export const TIPOHABITAT_ERROR = 'TIPOHABITAT_ERROR';

export const COLORESPECIE_LOADING = 'COLORESPECIE_LOADING';
export const COLORESPECIE_LOADED = 'COLORESPECIE_LOADED';
export const COLORESPECIE_ERROR = 'COLORESPECIE_ERROR';

export const ESPECIESIMILITUD_LOADING = 'ESPECIESIMILITUD_LOADING';
export const ESPECIESIMILITUD_LOADED = 'ESPECIESIMILITUD_LOADED';
export const ESPECIESIMILITUD_ERROR = 'ESPECIESIMILITUD_ERROR';

/* select */
export const SELECTREINO_LOADING = 'SELECTREINO_LOADING';
export const SELECTREINO_LOADED = 'SELECTREINO_LOADED';
export const SELECTREINO_ERROR = 'SELECTREINO_ERROR';

export const SELECTFILO_LOADING = 'SELECTFILO_LOADING';
export const SELECTFILO_LOADED = 'SELECTFILO_LOADED';
export const SELECTFILO_ERROR = 'SELECTFILO_ERROR';

export const SELECTSUBFILO_LOADING = 'SELECTSUBFILO_LOADING';
export const SELECTSUBFILO_LOADED = 'SELECTSUBFILO_LOADED';
export const SELECTSUBFILO_ERROR = 'SELECTSUBFILO_ERROR';

export const SELECTCLASE_LOADING = 'SELECTCLASE_LOADING';
export const SELECTCLASE_LOADED = 'SELECTCLASE_LOADED';
export const SELECTCLASE_ERROR = 'SELECTCLASE_ERROR';

export const SELECTINFRACLASE_LOADING = 'SELECTINFRACLASE_LOADING';
export const SELECTINFRACLASE_LOADED = 'SELECTINFRACLASE_LOADED';
export const SELECTINFRACLASE_ERROR = 'SELECTINFRACLASE_ERROR';

export const SELECTORDEN_LOADING = 'SELECTORDEN_LOADING';
export const SELECTORDEN_LOADED = 'SELECTORDEN_LOADED';
export const SELECTORDEN_ERROR = 'SELECTORDEN_ERROR';

export const SELECTSUBORDEN_LOADING = 'SELECTSUBORDEN_LOADING';
export const SELECTSUBORDEN_LOADED = 'SELECTSUBORDEN_LOADED';
export const SELECTSUBORDEN_ERROR = 'SELECTSUBORDEN_ERROR';

export const SELECTFAMILIA_LOADING = 'SELECTFAMILIA_LOADING';
export const SELECTFAMILIA_LOADED = 'SELECTFAMILIA_LOADED';
export const SELECTFAMILIA_ERROR = 'SELECTFAMILIA_ERROR';

export const SELECTSUBFAMILIA_LOADING = 'SELECTSUBFAMILIA_LOADING';
export const SELECTSUBFAMILIA_LOADED = 'SELECTSUBFAMILIA_LOADED';
export const SELECTSUBFAMILIA_ERROR = 'SELECTSUBFAMILIA_ERROR';

export const SELECTRIBU_LOADING = 'SELECTRIBU_LOADING';
export const SELECTRIBU_LOADED = 'SELECTRIBU_LOADED';
export const SELECTRIBU_ERROR = 'SELECTRIBU_ERROR';

export const SELECTGENERO_LOADING = 'SELECTGENERO_LOADING';
export const SELECTGENERO_LOADED = 'SELECTGENERO_LOADED';
export const SELECTGENERO_ERROR = 'SELECTGENERO_ERROR';

export const SELECTFICHA_LOADING = 'SELECTFICHA_LOADING';
export const SELECTFICHA_LOADED = 'SELECTFICHA_LOADED';
export const SELECTFICHA_ERROR = 'SELECTFICHA_ERROR';